import { gql } from "@apollo/client";

export const getPublishedSelfEnrollment = gql`
  query ($company_id: String, $domain: String) {
    getPublishedSelfEnrollment(company_id: $company_id, domain: $domain) {
      id
      title
      logo_url
      favicon_url
      gtm_id
      enabled
      ab_testing_weight
      domain

      primary_font
      secondary_font
      primary_color
      secondary_color

      phone_number
      redirect_url
      show_progress_bar
      contact_text
      company_id

      meta_title
      meta_description
      canonical_url
      allow_indexing

      order
      custom_pages {
        id
        slug
        page_title
        title
        subtitle
        input_type
        custom_field_id
        custom_field_name
        is_required
        input_label
        input_placeholder
        cta_type
        cta_value
        cta_button_text
      }
      settings {
        screening {
          visible
          questions {
            question
            options
            accepted_response
          }
        }
        email {
          visible
          title
          subtitle
          captcha
          opt_in
          opt_in_text
        }
        personal {
          visible
          title
          subtitle
          fields
        }
        phone {
          visible
          title
          validate_phone
          subtitle
          captcha
        }
        location {
          visible
          title
          subtitle
        }
        credit_report {
          visible
          title
          subtitle
          verify_title
          verify_subtitle
          agreement_content
        }
        credit_select {
          visible
          title
          verify_title
          minimum_selected_amount
          minimum_debt_amount
        }
        plan {
          visible
          title
          subtitle
          default_preview
          plan_ids
        }
        payment_scheduling {
          visible
          title
          subtitle
        }
        payment_info {
          visible
          title
          subtitle
        }
        review {
          visible
          title
          subtitle
          button_text
          agreement_content
          agreement_button_text
        }
        dead_end {
          title
          subtitle
          sub_subtitle
          button_text
        }
        success {
          visible
          title
          subtitle
          button_text
          steps_title
          cta_type
          cta_text
          cta_phone_number
          cta_email
          confetti
          steps {
            title
            description
          }
        }
      }
    }
  }
`;

export const getLead = gql`
  query getLead($id: ID!, $company_id: String!) {
    getLead(id: $id, company_id: $company_id) {
      id
      first_name
      middle_name
      last_name
      email
      email_opt_in
      phone
      dob
      ssn_last_4
      address
      address_line_two
      city
      state
      zip
      plaid
      current_step
      customFields
      bank {
        id
        name
        logo
        url
        account_type
        last_four
      }
      portal_url
      audit {
        agreement_url
      }
      plan {
        id
        type
        amount
        service_percent
        monthly_fees
        debt_amount
        months
        payment_schedule
        weekend_payments
        start_date
        next_date
        saved_plan {
          id
          name
          description
          type
          rate
          months
          background_color
          picture
          fees {
            id
            name
            type
            description
            who_for
            amount
          }
        }
      }
    }
  }
`;

export const getApplicationTradelines = gql`
  query getCurrentTradelines($application_id: ID!) {
    getCurrentTradelines(application_id: $application_id) {
      id
      short_id
      application_id
      credit_report_id
      selected
      is_custom
      tradeline {
        accountNumber
        accountType
        accountTypeText
        balanceAmount
        accountStatus
        openOrClosed
        customerName
        customerNumber
      }
    }
  }
`;

export const getCreditState = gql`
  query getCreditState($application_id: ID!) {
    getCreditState(application_id: $application_id) {
      ssns
      state
      creditSkipped
    }
  }
`;

export const getPlans = gql`
  query getPlans($application_id: ID, $company_id: String) {
    getPlans(application_id: $application_id, company_id: $company_id) {
      id
      name
      description
      type
      rate
      months
      background_color
      picture
      fees {
        id
        name
        type
        description
        who_for
        amount
      }
      updatedAt
    }
  }
`;

export const getCheckoutTradelines = gql`
  query getApplicationTradelines($id: ID) {
    getApplicationTradelines(id: $id) {
      tradelines {
        id
        short_id
        application_id
        credit_report_id
        selected
        is_custom
        is_co_applicant
        tradeline {
          accountNumber
          accountType
          accountTypeText
          balanceAmount
          scheduledPaymentAmount
          creditLimitAmount
          accountStatus
          openOrClosed
          customerName
          customerNumber
        }
      }
      selected
      total
      payment
      balance
      limit
    }
  }
`;

export const getAgreementData = gql`
  query getAgreementData($application_id: ID!) {
    getAgreementData(application_id: $application_id) {
      application {
        id
        audit {
          account_date
          credit_report_date
          plaid_date
          subscribed_date
        }
        bank {
          id
          name
          logo
          url
          account_type
          last_four
          cc_name
          cc_exp
          cc_cvc
          address
          address_line_two
          city
          state
          zip
        }
      }
      tradelines {
        id
        is_custom
        tradeline {
          accountNumber
          customerName
          balanceAmount
        }
      }
      payments {
        draft_date
        amount
      }
      ip_address
      parent_company {
        id
        name
        agreement_key
      }
    }
  }
`;

export const getSelfEnrollmentStats = gql`
  query getSelfEnrollmentStats($self_enrollment_id: String!) {
    getSelfEnrollmentStats(self_enrollment_id: $self_enrollment_id) {
      self_enrollment_id
      total_visits
      total_completed
      total_dead_ends
      screening
      email
      personal
      phone
      location
      credit_report
      credit_select
      plan
      payment_scheduling
      payment_info
      review
      success
    }
  }
`;
